module.exports = __webpack_public_path__ + "static/media/medallaOro.ca1a3f0a.png";